import { useParams } from 'react-router-dom';
import CardBlock from '../../components/bodyBlocks/cardsBlock/cardsBlock';
import '@/index.css';

const Profesionales = () => {
  const { servicio } = useParams<{ servicio?: string }>();

  return (
    <div >
      <CardBlock servicio={servicio} />
    </div>
  );
};

export default Profesionales;
